import React from "react";
import { useGetQuizzesQuery } from "../../../features/quizzes/quizzesApi";
import Error from "../../ui/Error";
import SingleQuiz from "./SingleQuiz";

export default function QuizList() {
  const {
    data: quizzes,
    isLoading,
    isError,
    error,
  } = useGetQuizzesQuery() || {};

  let content = null;

  if (isLoading) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        Loading...
      </div>
    );
  } else if (!isLoading && isError) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && quizzes?.length === 0) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        No Videos Found!
      </div>
    );
  } else if (!isLoading && !isError && quizzes?.length > 0) {
    content = quizzes.map((quiz) => {
      return <SingleQuiz key={quiz.id} quiz={quiz} />;
    });
  }
  return (
    <div className="overflow-x-auto mt-4">
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Question</th>
            <th className="table-th">Video</th>
            <th className="table-th justify-center">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">{content}</tbody>
      </table>
    </div>
  );
}
